import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// import { ReactComponent as CloseIcon } from '../../../assets/icons/close-circle.svg';
import { ReactComponent as NavigateArrow } from '../../../../assets/icons/device-management/navigate-back.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';
import { AvailableTabProperties } from '../../../../interface/station-management-side-panel.interface';
import MyButton from '../../../../shared-components/button/Button';
import SidePaneModel from '../../../../shared-components/table-side-panel/SidePaneModel';
import TabsContainer from '../../../../shared-components/tabs-container/TabsContainer';
import { permissionCheck } from '../../../../shared-functions/JWTDocodeFunction';
import AddStation from '../../station-management/components/AddStation';

import DeviceSearch from './DeviceSearch';

interface StationManagementTabsProperties {
  containerTabs: AvailableTabProperties[];
  handleSwitchTab: (key: string) => void;
}

/**
 * Station Management Tabs
 * @param {StationManagementTabsProperties} properties - The properties
 * @returns {React.JSX.Element} The rendered component
 */
function StationManagementTabs(properties: StationManagementTabsProperties) {
  const { t, i18n } = useTranslation('sidePanel');
  const navigate = useNavigate();
  const { containerTabs, handleSwitchTab } = properties;
  const location = useLocation();
  const [addStationOpen, setAddStationOpen] = useState(false);

  /**
   * Go back to parent function
   */
  const goBackToParent = () => {
    if (window.opener) {
      window.close();
      return;
    }

    const querySource = new URLSearchParams(location.search).get('source');
    const sourcePath = location.state?.source || querySource;

    if (sourcePath) {
      navigate(sourcePath);
    } else {
      // Fallback
      const updated = location.pathname.replace(/\/station\/[^/]+\/[^/]+$/, '');
      navigate(updated);
    }
  };

  return (
    <>
      <div className="container-tabs-wrap station-container-tabs-wrap" dir={i18n.dir()}>
        <button type="button" className="navigate-arrow" onClick={goBackToParent}>
          <span>
            <NavigateArrow />
          </span>
          <div className="navigate-background" />
        </button>
        <TabsContainer containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />
        <div className="close-icon" role="presentation">
          <DeviceSearch />
        </div>
        <div>
          <MyButton
            onClickFunc={() => setAddStationOpen(true)}
            label={t('addStation')}
            buttonType="outline"
            svgIcon={<PlusIcon />}
            disableClass="add-device-btn-custom"
            disableButton={
              !permissionCheck('partnerChargingStationAdd') &&
              !permissionCheck('cpoChargingStationAdd')
            }
          />
        </div>
      </div>
      {/* Add Station Panel */}
      <SidePaneModel
        open={addStationOpen}
        closePanel={() => setAddStationOpen(false)}
        content={<AddStation onClose={() => setAddStationOpen(false)} />}
        position="right"
        title="addStation"
      />
    </>
  );
}

export default StationManagementTabs;
